import 'uni-pages';
import Vue from 'vue'
import Page from './demo/packageEditor/rich-editor.vue'
createPage(Page)